export enum TemplateMail {     
     CompteAjoute=1,
     SejourAjoute=2,
     SejourValide=3,
     SejourAcces=4,
     ForgotPassword=5,     
     ChangePassword=6,
     CommandeAjoutee=7,
     CommandeValidee=8,
     CommandeAnnulée=9
}